import Select from 'corp/components/UI/Select';
import { RealReviewLevel, ReviewLevel, getSanitizedReviewLevel } from '@scale/shared/defaults';

const SelectReviewLevel = (props: $FIXME) => {
  const reviewLevels: any[] = RealReviewLevel.map(level => {
    return { value: level, label: getSanitizedReviewLevel(level) };
  });

  const options = reviewLevels;
  if (props.includeNoPermission) options.unshift({ value: -2, label: 'No Permission' });
  if (props.includeAnyPermission) options.unshift({ value: '', label: 'Any level' });
  if (props.includeDeliverable) options.push({ value: 12, label: 'L12' });
  if (props.includeL11) options.push({ value: 11, label: 'L11' });
  if (props.removeQIRLevels) {
    let deleteIndex = options.findIndex(el => el.value === ReviewLevel.QIRLeadAuditor);
    if (deleteIndex >= 0) options.splice(deleteIndex, 1);

    deleteIndex = options.findIndex(el => el.value === ReviewLevel.QIRAuditor);
    if (deleteIndex >= 0) options.splice(deleteIndex, 1);
  }

  return (
    <Select {...props} options={options} ignoreCase={false} placeholder="Select Review Level" />
  );
};
export default SelectReviewLevel;
